import { academicGroupRouteMetadata } from "../academicGroup/route";

import {
  facultyAcademicGroupMembersBreadcrumbs,
  facultyAcademicGroupMembersRoutesObj,
} from "./path";

import { concatRoutesMetadata, createRoute } from "@/routes/utils";
import type { IPartialRouteMetadataObj } from "@/routes/types";

const partialFacultyAcademicGroupMembersRoutesMetadata: IPartialRouteMetadataObj<
  typeof facultyAcademicGroupMembersRoutesObj
> = {
  list: {
    title: "facultyMembersList",
    lazy: () =>
      import(
        "@/pages/adminPanel/facultyManagement/facultyAcademicGroupMembers/table/page"
      ),
    mode: "index",
  },
  create: {
    title: "addFacultyMember",
    lazy: () =>
      import(
        "@/pages/adminPanel/facultyManagement/facultyAcademicGroupMembers/form/page"
      ),
    mode: "create",
  },
  edit: {
    title: "editFacultyMemberOf",
    lazy: () =>
      import(
        "@/pages/adminPanel/facultyManagement/facultyAcademicGroupMembers/form/page"
      ),
    mode: "edit",
  },
  view: {
    title: "viewFacultyMemberOf",
    lazy: () =>
      import(
        "@/pages/adminPanel/facultyManagement/facultyAcademicGroupMembers/form/page"
      ),
    mode: "view",
  },
};

const facultyAcademicGroupMembersRoutesMetadata = concatRoutesMetadata<
  typeof facultyAcademicGroupMembersRoutesObj
>(academicGroupRouteMetadata, partialFacultyAcademicGroupMembersRoutesMetadata);

export const facultyAcademicGroupMembersRoutes = createRoute<
  typeof facultyAcademicGroupMembersRoutesObj
>(
  facultyAcademicGroupMembersRoutesObj,
  facultyAcademicGroupMembersRoutesMetadata,
  facultyAcademicGroupMembersBreadcrumbs,
);
